/**
 * Supporting Documentation group and item config.
 * Drives both the top-level dashboard and each group sub-dashboard.
 */
export const SUPPORTING_DOCS_GROUPS = [
  {
    id: 'general',
    label: 'General',
    route: 'supportingdocs-general',
    description: 'Project-level reference data: buildings, sources, disciplines, and system codes.',
    items: [
      { slug: 'buildings',    label: 'Building',     description: 'Define building identifiers used to organize panels, tags, and equipment by physical location.' },
      { slug: 'source',       label: 'Source',        description: 'Manage signal source definitions referenced during tag and IO configuration.' },
      { slug: 'discipline',   label: 'Discipline',    description: 'Define engineering disciplines (Electrical, Instrumentation, etc.) used to categorize project scope.' },
      { slug: 'system-code',  label: 'System Code',   description: 'Manage system code identifiers used for grouping and filtering equipment across the project.' }
    ]
  },
  {
    id: 'panels',
    label: 'Panels',
    route: 'supportingdocs-panels',
    description: 'Panel reference data: card types, panel types, terminal configurations, and transfer parties.',
    items: [
      { slug: 'card-type',        label: 'Card Type',       description: 'Define IO card types used in panel slot assignments and IO buffer generation.' },
      { slug: 'panel-type',       label: 'Panel Type',      description: 'Manage panel type definitions that categorize control and distribution enclosures.' },
      { slug: 'panel-terminal',   label: 'Panel Terminal',  description: 'Configure panel terminal strip definitions used in wiring documentation.' },
      { slug: 'transfer-party',   label: 'Transfer Party',  description: 'Define parties responsible for material transfer associated with panels.' }
    ]
  },
  {
    id: 'tags',
    label: 'Tags',
    route: 'supportingdocs-tags',
    description: 'Tag reference data: ISA types, engineering units, wire types, valve sizes, and transfer parties.',
    items: [
      { slug: 'isa-type',     label: 'ISA Type',           description: 'Define ISA instrument type codes used to classify field devices and IO tags.' },
      { slug: 'eng-units',    label: 'Engineering Units',  description: 'Manage engineering unit definitions applied to analog tags for display and scaling.' },
      { slug: 'wire-type',    label: 'Wire Type',          description: 'Define wire type specifications referenced in field wiring and panel documentation.' },
      { slug: 'valve-size',   label: 'Valve Size',         description: 'Manage valve size options used in tag configuration and equipment schedules.' },
      { slug: 'transfer-party', label: 'Transfer Party',   description: 'Define parties responsible for material transfer associated with tagged equipment.' }
    ]
  },
  {
    id: 'index',
    label: 'Index',
    route: 'supportingdocs-index',
    description: 'Index and manufacturer reference data used in drawing logs and submittal packages.',
    items: [
      { slug: 'index-sheet',   label: 'Index Sheet',   description: 'Manage drawing index sheet entries used in the project drawing register.' },
      { slug: 'manufacturer',  label: 'Manufacturer',  description: 'Define equipment manufacturers referenced in submittal and procurement records.' }
    ]
  },
  {
    id: 'network',
    label: 'Network',
    route: 'supportingdocs-network',
    description: 'Network reference data: subnet definitions for IP address management.',
    items: [
      { slug: 'subnet', label: 'Subnet', description: 'Define network subnets used to organize and validate IP address assignments across the project.' }
    ]
  },
  {
    id: 'commissioning',
    label: 'Commissioning',
    route: 'supportingdocs-commissioning',
    description: 'Commissioning reference data: key definitions used in OAT and QAQC records.',
    items: [
      { slug: 'commissioning-key', label: 'Commissioning Key', description: 'Define commissioning key identifiers used to group and track OAT and QAQC activities by system.' }
    ]
  }
];
